import { Box, Tabs, Tab } from '@mui/material'
import { useEffect, useState } from 'react'
import { Statsig } from 'statsig-react'
import { useRouter } from 'next/router'
import PriceChart from './components/priceChart'
import { BED_ROOMS_INFO_LIST } from './constData'

const LineChart = ({ medianRentsTrends = [], filterBy, isPC }) => {
  const [value, setValue] = useState(BED_ROOMS_INFO_LIST[0].key)
  const [show, setShow] = useState(false)
  const { asPath } = useRouter()
  const { city, area } = filterBy || {}
  const tabIdx = BED_ROOMS_INFO_LIST.findIndex(v => v.key === value)

  const onChangeTab = (_, newValue) => {
    setValue(newValue)
    const { floorPlanName = '' } = medianRentsTrends[tabIdx] || {}

    if (process.env.STATSIG_API_KEY) {
      Statsig.logEvent('market_trends_median_price_click', asPath, {
        city,
        region: area,
        apartment_type: floorPlanName
      })
    }
  }

  useEffect(() => {
    const { medianRentsTrendsDetails } = medianRentsTrends?.[tabIdx] || {}
    const { medianRentsPrice = [], yearMonth = [] } = medianRentsTrendsDetails || {}
    setShow(medianRentsPrice.length > 0 && yearMonth.length > 0)
  }, [tabIdx, medianRentsTrends])

  const { medianRentsTrendsDetails = {} } =
    (medianRentsTrends || []).filter(
      ({ floorPlanName }) => Number(floorPlanName) === tabIdx
    )?.[0] || {}

  return (
    <>
      <Box component="h2" className="mt-15 mb-6 lg:mt-20 font-ramaraja text-4xl">
        Median rents trends in {area || city}
      </Box>
      <Tabs
        sx={{
          minHeight: 'auto',
          '& .MuiTabs-indicator': {
            background: '#004D34'
          }
        }}
        variant="scrollable"
        scrollButtons={false}
        aria-label="scrollable auto tabs"
        value={value}
        onChange={onChangeTab}
      >
        {BED_ROOMS_INFO_LIST.map(({ label, key }) => (
          <Tab
            key={key}
            className={`capitalize mr-4 lg:mr-9 last:mr-0 text-lg font-semibold max-h-12 ${
              key === value ? 'text-brand' : 'text-secondary'
            }`}
            label={label}
            disableRipple
            value={key}
            sx={{
              '&.MuiTab-root': {
                minWidth: 'auto',
                padding: 0,
                minHeight: 'auto',
                maxHeight: 'auto',
                height: '36px'
              }
            }}
          />
        ))}
      </Tabs>
      <Box className="w-full h-[400px] relative mt-6">
        {show ? <PriceChart lineData={medianRentsTrendsDetails} isPC={isPC} /> : ''}
      </Box>
    </>
  )
}

export default LineChart
